import { ProjectAction } from "../types/projectDataKeywords"
import { Dispatch } from "react"
import { ProjectActionType } from "../types/projectDataKeywords"
import projectApi from "../../api/projectDataKeywordsApi"

function getProjectDataKeywords(projectId: string) {
  return async (dispatch: Dispatch<ProjectAction>) => {
    try {
      dispatch({ type: ProjectActionType.FETCH_PROJECT_DATA_KEYWORDS })
      const response = await projectApi.getKeywordsData(projectId)
      dispatch({ type: ProjectActionType.FETCH_PROJECT_DATA_KEYWORDS_SUCCESS, payload: response })
    } catch (error) {
      dispatch({
        type: ProjectActionType.FETCH_PROJECT_DATA_KEYWORDS_ERROR,
        payload: "Error loading projects",
      })
    }
  }
}

export default {
  getProjectDataKeywords,
}
